module.exports = __webpack_public_path__ + "static/media/vsimg.72758ed5.png";